/* eslint-disable no-unused-vars */
enum AttributeTypes {
  Textbox = 'textbox',
  TextboxNumber = 'textbox_numeric',
  DropdownSingleSelect = 'dropdown',
  DropdownMultiSelect = 'dropdown_multiselect',
  DateTimeSingle = 'datetime_single',
  DateTimeRange = 'datetime_range',
}

export { AttributeTypes };
